module.exports = __webpack_public_path__ + "static/media/ps_modal_wire_red.5f99bbd2.svg";